import { render, staticRenderFns } from "./checklist_item.vue?vue&type=template&id=6b335d3c&"
import script from "./checklist_item.vue?vue&type=script&lang=js&"
export * from "./checklist_item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports